import { createSelector, createFeatureSelector } from '@ngrx/store';
import * as fromNote from '../_reducers/note';

export const selectNoteState = createFeatureSelector<fromNote.NoteState>('notes');

export const selectAllNotes = createSelector(selectNoteState, fromNote.selectAll);

export const selectNoteEntities = createSelector(selectNoteState, fromNote.selectEntities);

export const selectNoteById = (id: number) =>
  createSelector(selectNoteEntities, (entities) => entities[id]);

export const selectNoteTotal = createSelector(selectNoteState, fromNote.selectTotal);
